import * as angular from 'angular';

export class SearchSelectorItemController {
  public item: any; // item is a "hit" from a resulting algolia query
  static $inject = [];
  constructor() {}
  $onInit() {}
}

export const SearchSelectorItem: angular.IComponentOptions = {
  controller: SearchSelectorItemController,
  controllerAs: 'ctrl',
  bindings: {
    item: '<',
  },
  template: `
  <div class="search-selector-item-container">
    <span class="item-icon" ng-if="ctrl.item.objectType === 'user'">
      <!-- Avatar for Users -->
      <mode-avatar options="ctrl.item.avatar" size="32"></mode-avatar>
    </span>

    <span class="item-icon" ng-if="ctrl.item.objectType === 'user_group'">
      <!-- Avatar for Groups -->
      <div class="icon-groups-avatar"></div>
    </span>

    <span class="item-labels">
      {{ ctrl.item.name }}
    </span>
  </div>

`,
};
